import React from 'react';
import './footerNav.scss';
import inicioIcon from '../../../assets/inicio.svg';
import rutaIcon from '../../../assets/ruta.svg';
import juegosIcon from '../../../assets/pieza-rompecabezas-gris.png';

const FooterNav = () => {
  const baseURL = process.env.REACT_APP_REDIRECT_URL;

  const footerNavOptions = [
    {
      title: 'Inicio',
      icon: inicioIcon,
      redirectURL: baseURL + '/',
    },
    {
      title: 'Ruta',
      icon: rutaIcon,
      redirectURL: baseURL + '/ruta',
    },
    {
      title: 'Juguemos',
      icon: juegosIcon,
      redirectURL: baseURL + '/perfil',
    },
  ];

  return (
    <nav className="footer-nav" style={{ gridTemplateColumns: `repeat(${footerNavOptions.length}, 1fr)` }} data-testid="footer-nav">
      {footerNavOptions.map((option) => {
        let isActive = window.location.href === option.redirectURL;

        return (
          <a
            className={isActive ? 'footer-nav--active' : ''}
            href={option.redirectURL}
            rel="noreferrer"
            key={option.title}
            data-testid={`footer-nav-item-${option.title.toLowerCase()}`}
          >
            <img src={option.icon} alt={option.title}></img>
            <p>{option.title}</p>
          </a>
        );
      })}
    </nav>
  );
};

export default FooterNav;
